// extracted by mini-css-extract-plugin
export default {"excelView":"CoaExcelView_excelView__rXSQI"};